export default __webpack_public_path__ + "static/media/330_dummy2016-lebenslaufbusiness01-mobile.1c5ca5f8.png";